import { render, staticRenderFns } from "./RybBill.vue?vue&type=template&id=4d88c4e3&scoped=true&"
import script from "./RybBill.vue?vue&type=script&lang=js&"
export * from "./RybBill.vue?vue&type=script&lang=js&"
import style0 from "./RybBill.vue?vue&type=style&index=0&id=4d88c4e3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d88c4e3",
  null
  
)

export default component.exports